import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import AboutUs from '../components/AboutUs';
import Impact from '../components/Impact';
import Leadership from '../components/Leadership';

function AboutPage() {
  return (
    <div className="min-h-screen bg-brand-white font-sans">
      <Header />

      <section className="page-banner">
        <img
          src="/images/about-banner.png"
          alt="FutureLeadX students and professionals"
          className="absolute inset-0 h-full w-full object-cover object-right"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-white via-brand-white/90 to-transparent sm:from-brand-white/95 sm:via-brand-white/70 sm:to-transparent lg:from-brand-white/80 lg:via-brand-white/35 lg:to-transparent" />

        <div className="page-shell relative z-10 flex min-h-[inherit] items-center py-12">
          <div className="max-w-xl">
            <h1 className="text-[34px] font-bold leading-[1.08] tracking-tight text-brand-navy sm:text-[44px] lg:text-[52px]">
              Empowering
              <br />
              Future Industry
              <br />
              Leaders
            </h1>

            <p className="mt-5 max-w-md text-body-sm leading-relaxed text-brand-secondary sm:text-body">
              FutureLeadX is a skilling and career development initiative by BPS
              Group, built to bridge the gap between education and industry.
            </p>

            <div className="mt-8 flex flex-wrap items-center gap-3">
              <a href="#about" className="btn-primary">
                Know More
              </a>
              <Link to="/programs" className="btn-outline">
                Our Programs
              </Link>
            </div>
          </div>
        </div>
      </section>

      <AboutUs />
      <Impact />
      <Leadership />
      <Footer />
    </div>
  );
}

export default AboutPage;
